
import React, { Component, useEffect, useState } from 'react';
import { ActionInterface, ActionTakenType, ProfileCollectPayload, ProfileCollectStatus, UserVars, createActionTaken } from '@swivl/swivl-lib'


import './ProfileCollect.scss';
import { ListItemData } from '../../ListItem';
import { MessageHandlerInterface } from '../../../../messages/MessageHandler';
import { Spinner } from '../../../../components/Spinner/Spinner';
import parsePhoneNumberFromString from 'libphonenumber-js';
import { ProfileCollectValidationError, ValidateProfileCollect } from './ProfileValidator';


export interface ProfileCollectProps {
  item: ListItemData;
  messageHandler: MessageHandlerInterface;
  isActive: boolean;
}
export interface ProfileCollectState {
  selectedActions: Array<string>;
}
export function ProfileCollect(props: ProfileCollectProps) {
  const { item, isActive,messageHandler } = props;
  const [state, setState] = useState<ProfileCollectPayload>(item.message.payload as ProfileCollectPayload)
  const [saving, setSaving] = useState<boolean>(false)
  const [validationErrors, setValidationErrors] = useState<ProfileCollectValidationError>({})
  const payload = item.message.payload as ProfileCollectPayload;

  useEffect(() => {
    setState(payload);
  }, [item.message.payload])



  const submitClicked = () => {
    setSaving(true);
    const validations = ValidateProfileCollect(payload);
    if (Object.values(validations.validationErrors).length) {
      setValidationErrors(validations.validationErrors);
      setSaving(false);
      return;
    } 
    setState(validations.payload);

    const messageId = item.message.id;
    const actionTaken = createActionTaken(ActionTakenType.Other, "saved", {items:validations.payload.items})
    
    messageHandler.actionTaken(messageId, actionTaken);


    setSaving(false);

    const el = document.getElementById("scc-form-input");
    if (el) {
      el.focus();
    }

  }
  const cancelClicked = () => {
    const messageId = item.message.id;
    const actionTaken = createActionTaken(ActionTakenType.Other, "canceled", {})
    messageHandler.actionTaken(messageId, actionTaken);

  }

  const actionTaken = item.message.actionTaken; 


  const active = (!actionTaken && isActive && payload.status === ProfileCollectStatus.PENDING);
  const actionTakenItems = item.message.actionTaken?.data?.items; 



    return <div className="scc-ProfileCollect">
      <div className="scc-ProfileCollectCard">
        {state.items.map((item, index) => {
          let value = actionTakenItems?.[index]?.value || item.value;
          if (!active && (!value || !value.length)) { 
            value = "--"
          }


          return <div className={validationErrors[item.id]?.length ? "scc-ProfileCollectCardItem scc-validationError" : "scc-ProfileCollectCardItem"} key={index}>
            <label>{item.label} {!item.required && active ? " (optional) " : null} {active && <span className="scc-profileValidationError">{validationErrors[item.id]}</span>}</label>
            {active ? <input
              type="text"
              value={value}
              placeholder={item.placeholder}
              onKeyUp={(e) => {
                if (e.key === "Enter") {
                  submitClicked();
                }
              }}
              onChange={(e) => {
                const newState = { ...state };
                newState.items[index].value = e.target.value;
                setState(newState);
              }} /> : <div className="scc-ProfileCollectCardItemValue">{value}</div>}

          </div>
        })}
        {active && <div className="scc-ProfileCollectCardButtons">
          <button className="scc-ProfileCancelButton" onClick={() => { cancelClicked() }}>Cancel</button>
          <button className="scc-ProfileSaveButton swivl-sendButton"  disabled={saving}  onClick={() => {
            if (saving) { return; }
            submitClicked();
           }}>
           {saving ? <Spinner /> : state.actionButtonText}</button>
        </div> }
      </div>
      {!active && actionTaken && actionTaken.target === "canceled" && <div className="scc-ProfileInfoLine">Canceled</div>} 
      {active && <div className="scc-ProfileInfoLine">Please provide your information to continue</div>}
    </div>

 
}


